import { Controller } from '@hotwired/stimulus';

export default class extends Controller<HTMLElement> {
    private revealedHash = '';

    connect(): void { this.reveal(); }

    reveal(): void {
        const hash = window.location.hash;
        if (!hash || hash === this.revealedHash) return;
        let id: string;
        try { id = decodeURIComponent(hash.slice(1)); } catch { return; }
        const target = document.getElementById(id);
        if (!target || !this.element.contains(target)) return;
        this.revealedHash = hash;
        for (let parent = target.parentElement; parent && this.element.contains(parent); parent = parent.parentElement) {
            if (parent instanceof HTMLDetailsElement && !parent.open) {
                // Anchor navigation must reveal the content before scrolling to it.
                parent.classList.add("[&::details-content]:transition-none");
                parent.open = true;
            }
        }
        requestAnimationFrame(() => {
            if (target.isConnected && window.location.hash === hash) target.scrollIntoView({ block: 'start' });
        });
    }
}
